/**
 * rainviewerTile · v2.7.34 (2026-02-21)
 * ═══════════════════════════════════════════════════════════════════
 * RainViewer caps its tile coverage at zoom level 10. At z > 10 their
 * server returns a "Zoom Level Not Supported" placeholder PNG.
 *
 * To keep the radar visible at street-level zoom without that
 * placeholder + without abruptly losing the overlay, we transparently
 * substitute the parent tile from z=10. The same parent image will be
 * served for the 4 / 16 / 64 child tiles at z=11 / 12 / 13, producing
 * a blocky upscale instead of a hard disappearance — operationally
 * sufficient for "is there rain at street level".
 *
 * Usage:
 *   import { rainviewerTileUrl } from "@/lib/rainviewerTile";
 *   const url = rainviewerTileUrl(host, path, coord.x, coord.y, zoom);
 */
const MAX_NATIVE_ZOOM = 10;

export function rainviewerTileUrl(host, path, x, y, zoom, color = 4, options = "1_1") {
  if (!host || !path) return null;
  let z = zoom, tx = x, ty = y;
  if (z > MAX_NATIVE_ZOOM) {
    const dz = z - MAX_NATIVE_ZOOM;
    tx = x >> dz;
    ty = y >> dz;
    z = MAX_NATIVE_ZOOM;
  }
  return `${host}${path}/256/${z}/${tx}/${ty}/${color}/${options}.png`;
}
